var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGithub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0.666016C7.16 0.666016 0 7.70602 0 16.3887C0 23.3367 4.584 29.2287 10.94 31.306C11.74 31.454 12.0333 30.9674 12.0333 30.55C12.0333 30.1767 12.02 29.1874 12.0133 27.8767C7.56267 28.8247 6.624 25.7674 6.624 25.7674C5.896 23.9527 4.844 23.4674 4.844 23.4674C3.39467 22.4927 4.956 22.5127 4.956 22.5127C6.56267 22.622 7.40667 24.1327 7.40667 24.1327C8.83333 26.5367 11.152 25.842 12.0667 25.4407C12.2107 24.4234 12.6227 23.7314 13.08 23.338C9.52667 22.9447 5.792 21.5927 5.792 15.5687C5.792 13.8527 6.412 12.45 7.43867 11.35C7.25867 10.9527 6.71867 9.35402 7.57867 7.18868C7.57867 7.18868 8.91867 6.76735 11.9787 8.80068C13.2587 8.45135 14.6187 8.27802 15.9787 8.27002C17.3387 8.27802 18.6987 8.45135 19.9787 8.80068C23.0187 6.76735 24.3587 7.18868 24.3587 7.18868C25.2187 9.35402 24.6787 10.9527 24.5187 11.35C25.5387 12.45 26.1587 13.8527 26.1587 15.5687C26.1587 21.6087 22.4187 22.938 18.8587 23.3247C19.4187 23.7967 19.9387 24.7607 19.9387 26.234C19.9387 28.338 19.9187 30.0287 19.9187 30.5394C19.9187 30.9514 20.1987 31.4434 21.0187 31.286C27.42 29.222 32 23.326 32 16.3887C32 7.70602 24.836 0.666016 16 0.666016Z",
    fill: "#92A7BA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.39738b5ca1257f02d3543c26a7cd05da.svg";
export { ForwardRef as ReactComponent };